import { useState } from "react"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { Box, Stack, useTheme } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { DifferenceTitle } from "routes/schedule/compare/difference-title"
import { Status } from "routes/schedule/compare/status"
import { Comparison } from "routes/schedule/compare/lib/diff3"
import { EditModeSwitch } from "routes/schedule/compare/edit-mode-switch"
import { Editable } from "lib/@components/editable"
import { Approved } from "routes/schedule/compare/approved"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"

export function TextDifference({ path, label = path }) {
    const { to, target } = useBoundContext()
    const [value1, setValue] = useBoundValue(path)
    const [copied, setCopied] = useState(false)
    const [hover, setHover] = useState(false)
    const [original] = useState(value1)
    const theme = useTheme()

    const value2 = Object.get(to, path, true)
    return (
        <DifferenceWrapper label={`${target.title}: ${label}`}>
            <Stack ml={-1} spacing={0} sx={{ width: "100%", wordBreak: "break-word" }}>
                <DifferenceTitle label={label} />
                <ListItemBox alignItems="center">
                    <Box flex={1} ml={1} mr={5} sx={{ opacity: hover ? 0.25 : 1, transition: "opacity 0.2s linear" }}>
                        <EditModeSwitch>
                            <Editable editor={<BoundTextField size="small" fullWidth label="" field={path} />}>
                                <Box
                                    borderRadius={1}
                                    py={0.95}
                                    px={1.65}
                                    sx={{ border: "1px solid", borderColor: "action.hover" }}
                                >
                                    <Comparison original={value2} other={value2} text={value1} />
                                </Box>
                            </Editable>
                        </EditModeSwitch>
                    </Box>
                    <Approved>
                        <Status path={path} onHover={setHover} revert={revert} copy={copy} onCopyChanged={setCopied} />
                        <Box
                            flex={1}
                            px={3}
                            sx={{
                                borderRadius: 1,
                                opacity: copied ? 0.5 : 1,
                                transition: "background-color linear 0.2s",
                                bgcolor: hover ? `${theme.palette.primary.main}20` : undefined,
                            }}
                        >
                            <Box
                                borderRadius={1}
                                py={1}
                                px={2}
                                sx={{ border: "1px solid", borderColor: "action.hover" }}
                            >
                                <Comparison original={value1} other={value1} text={value2} />
                            </Box>
                        </Box>
                    </Approved>
                </ListItemBox>
            </Stack>
        </DifferenceWrapper>
    )

    function copy() {
        setValue(value2)
    }

    function revert() {
        setValue(original)
    }
}
